import { css } from '@emotion/react';

export default css({
  '&.tt-uploaded-icon': {
    width: '30px',
    height: '30px',
    borderRadius: '4px',
    alignItems: 'center',
  },
  '.tt-uploaded-icon__icon': {
    height: '20px',
    width: 'auto',
  },
});
